module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "trellis-assets": "static-1.1885"
    },
    "depPathPrefixes": {
      "trellis-assets": "/trellis-assets/static-1.1885"
    },
    "bundlingPackage": "page-editor-ui",
    "bundlingPackageVersion": "static-1.38322",
    "project": "trellis-assets",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};